// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

// CSS
import './styles.scss'

// Img
import triangleImg from '../../assets/triangle.svg'

// Component/Container
import NotifyCard from './components/NotifyCard'
import HeaderPopUp from '../Header/components/HeaderPopUp'

// Actions
import { changeBrowserNotification } from './actions'
import { changeHeaderVisible } from '../Header/actions'

// Imgs
import logoImg from '../../assets/logos/com-acordo-icon.png'

class Notify extends Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { browserNotification, notifications, changeBrowserNotification } = this.props
    const { browserNotification: nextBrowserNotification, notifications: nextNotifications } = nextProps

    if (!browserNotification && !_.isEmpty(notifications) && (nextNotifications.length > notifications.length)) {
      if ('Notification' in window) changeBrowserNotification(true)

    } else if (nextBrowserNotification) {
      changeBrowserNotification(false)
    }
  }

  createNotification = () => {
    const { notifications } = this.props
    const { proposta_id: propostaId } = notifications[0]

    const notification = new window.Notification(
      'Com Acordo',
      {
        body: `Ocorreu alteração no caso ${propostaId}`,
        icon: logoImg
      }
    )

    notification.onclick = event => {
      let url = 'https://comacordo.com.br'

      if (document.location.hostname.indexOf("localhost") !== -1) {
        url = 'http://localhost:3000'
      }

      event.preventDefault()
      window.open(`${url}/meus-casos/${propostaId}`, '_blank')
    }

    setTimeout(notification.close.bind(notification), 10000)
  }

  render() {
    const { visible, browserNotification, notifications, changeBrowserNotification, changeHeaderVisible } = this.props
    const { createNotification } = this

    return (
      <HeaderPopUp
        visible={visible.status && visible.type === 'notify'}
        icon="notifications"
        width={370}
        title={`Pendências (${notifications.length})`}
        notifications={notifications}
        toggleVisible={() => changeHeaderVisible('notify')}>
        {!_.isEmpty(notifications) && notifications.map(notification => (
          <NotifyCard
            key={notification.id}
            propostaId={notification.proposta_id}
            status={notification.status}
            subStatus={notification.sub_status}
            text={notification.text}
            date={notification.date}
            onClick={() => changeHeaderVisible('notify')} />
        ))}
        {_.isEmpty(notifications) && (
          <div className="notify__none">
            Você não possui pendência.
          </div>
        )}
        {browserNotification && createNotification()}
      </HeaderPopUp>
    )
  }
}

Notify = connect(state => {
  return {
    visible: state.header.visible,
    browserNotification: state.notify.browserNotification,
    notifications: state.notify.notifications
  }
}, { changeBrowserNotification, changeHeaderVisible })(Notify)

export default Notify
